<template>
    <div class="container-fluid" v-if="Object.keys(offer).length">
        <h4>
            {{ offer.name[locale] }}
            <router-link
                v-if="$store.getters.canEditOffers"
                :to="{ name: 'specialoffers.edit', params: { offer_id: offer.id } }"
                class="btn btn-primary btn-sm text-white float-right">
                {{ $t('Edit') }}
            </router-link>
        </h4>
        <div class="clearfix"></div>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Name') }}</label>
                    <p class="custom-gray-input-bg">{{ offer.name[locale] }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Start') }}</label>
                    <p class="custom-gray-input-bg">{{ offer.start_date | formatDate }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('End') }}</label>
                    <p class="custom-gray-input-bg">{{ offer.end_date | formatDate }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Discount') }} %</label>
                    <p class="custom-gray-input-bg">{{ offer.discount_percent }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Comments') }}</label>
                    <div class="custom-gray-input-bg" v-html="offer.comments[locale]" />
                </div>
            </div>
        </div>

        <hr v-if="offer.dbname" />
        <div v-if="offer.dbname" class="row">
            <div class="col">
                <h4>{{ $t('Images') }}</h4>
                <div class="float-left" style="position: relative">
                    <span v-if="$store.getters.canDeleteOffers" class="mdi mdi-24px mdi-trash-can-outline trash-img" @click="destroyImg" />
                    <img :src="`${envUrl}/offers/${offer.dbname}`" width="160px" height="auto" class="img-thumbnail" />
                </div>
            </div>
        </div>

        <hr v-if="offer.vehicles && offer.vehicles.length" />
        <div class="row" v-if="offer.vehicles.length">
            <div class="col">
                <h4>{{ $t('Vehicles') }}</h4>
                <div class="table-responsive">
                    <table class="table table-striped table-sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{{ $t('Make') }}</th>
                                <th>{{ $t('Model') }}</th>
                                <th>{{ $t('Year') }}</th>
                                <th>{{ $t('Transmission') }}</th>
                                <th>{{ $t('Type') }}</th>
                                <th>{{ $t('Color') }}</th>
                                <th>{{ $t('Active') }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(vehicle, i) in offer.vehicles" :key="i">
                                <td>{{ i + 1 }}</td>
                                <td>{{ vehicle.make.name }}</td>
                                <td>{{ vehicle.model.name }}</td>
                                <td>{{ vehicle.year }}</td>
                                <td>{{ $t(vehicle.transmission.name) }}</td>
                                <td>{{ $t(vehicle.type.name) }}</td>
                                <td>{{ vehicle.color[locale] }}</td>
                                <td>{{ vehicle.active ? $t('Yes') : '' }}</td>
                                <td class="p-0">
                                    <div class="text-right">
                                        <router-link v-if="$store.getters.canViewVehicles" :to="{ name: 'vehicles.show', params: { vehicle_id: vehicle.id } }" class="btn btn-info btn-sm text-white">
                                            {{ $t('View') }}
                                        </router-link>
                                        <app-button v-if="$store.getters.canEditOffers" native-type="button" type="danger" @click="removeVehicleFromOffer(vehicle.id)" small>
                                            {{ $t('Remove') }}
                                        </app-button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SpecialOfferService from '@services/specialOffer.service';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            offer: {}
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        removeVehicleFromOffer(vehicleId) {
            if (!window.confirm(`${this.$t('Remove vehicle from offer')}?`)) {
                return false;
            }
            SpecialOfferService.removeVehicleFromOffer(this.offer.id, vehicleId).then(res => {
                this.offer = res;
            });
        },
        getSpecialOffer(offerId) {
            SpecialOfferService.show(offerId).then(res => (this.offer = res));
        },
        destroyImg() {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            SpecialOfferService.destroyImg(this.offer.id).then(res => {
                this.offer.dbname = null;
                this.offer.filename = null;
            });
        }
    },
    created() {
        this.getSpecialOffer(this.$route.params.offer_id);
    }
};
</script>
